var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "title d-flex flex-wrap align-center primary--text font-weight-medium gap-2 mb-4",
        },
        [
          _c(
            "v-icon",
            { staticClass: "mr-2", attrs: { size: "20", color: "primary" } },
            [_vm._v(" mdi-note-edit ")]
          ),
          _c("div", [_vm._v("จัดการแบรนด์")]),
          _c("v-spacer"),
          _c(
            "div",
            { staticClass: "d-flex gap-2" },
            [
              _c(
                "div",
                { staticClass: "font-weight-regular" },
                [
                  _c("v-text-field", {
                    attrs: {
                      value: _vm.searchText,
                      placeholder: "ค้นหาแบรนด์",
                      "append-icon": "mdi-magnify",
                      autocomplete: "off",
                      "background-color": "#ffffff",
                      "hide-details": "",
                      outlined: "",
                      dense: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setSearchTextDebounce($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c("UpdateDialog", {
                attrs: { "is-update": false },
                on: {
                  onRefetch: function ($event) {
                    return _vm.onRefetch()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "p-5 rounded-lg", attrs: { flat: "" } },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-space-between" },
            [
              _c("div", { staticClass: "title primary--text mb-5" }, [
                _vm._v(
                  " รายการแบรนด์ (" +
                    _vm._s(_vm.productBrandList.nodesCount) +
                    ") "
                ),
              ]),
              _vm.selected.length > 0
                ? _c("DeleteDialog", {
                    attrs: { "brand-list": _vm.selected },
                    on: {
                      onRefetch: function ($event) {
                        return _vm.onRefetch()
                      },
                      deleteSuccess: function ($event) {
                        return _vm.clearSelect()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("v-data-table", {
            staticClass: "elevation-0 brand-table",
            attrs: {
              loading: _vm.loading,
              headers: _vm.headers,
              items: _vm.productBrandList.nodes,
              "items-per-page": _vm.perPage,
              page: _vm.page,
              "checkbox-color": "primary",
              "show-select": "",
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.action`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-center align-center" },
                        [
                          _c("UpdateDialog", {
                            attrs: {
                              "brand-name": item.name,
                              "brand-id": item.id,
                              "is-update": true,
                            },
                          }),
                          _c("DeleteDialog", {
                            attrs: {
                              "brand-name": item.name,
                              "brand-id": item.id,
                            },
                            on: {
                              onRefetch: function ($event) {
                                return _vm.onRefetch()
                              },
                              deleteSuccess: function ($event) {
                                return _vm.clearSelect()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c("snt-pagination", {
                        attrs: {
                          "total-pages": _vm.productBrandList.pagesCount,
                        },
                        model: {
                          value: _vm.page,
                          callback: function ($$v) {
                            _vm.page = $$v
                          },
                          expression: "page",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.selected,
              callback: function ($$v) {
                _vm.selected = $$v
              },
              expression: "selected",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }